import { makeStyles } from '@policygenius/mortar';

type Classes = 'slider' | 'thumb';

export const SLIDER_HEIGHT = 20;

export default makeStyles<null, Classes>(({ colors }) => ({
  slider: {
    height: SLIDER_HEIGHT,
  },
  thumb: {
    position: 'absolute',
    backgroundColor: colors.orange400,
    borderRadius: '50%',
    width: SLIDER_HEIGHT,
    height: SLIDER_HEIGHT,
  },
}));
